import store from 'store/index';

export const accessTokenInterceptor = {
  onConfig: (config) => {
    const accessToken = store?.getState()?.auth?.accessToken;
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  onError: (error) => Promise.reject(error),
};
